module.exports = __webpack_public_path__ + "img/undraw_add_to_cart_re_wrdo.e882da96.svg";